export const SIGN_UP_STEP = {
    VERIFY_EMAIL: 'verifyEmail',
    FILL_PROFILE: 'fillProfile',
};
